var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',_vm._b({class:{'mr-2': _vm.useMRRight},attrs:{"text":_vm.text}},'Tooltip',_vm.$attrs,false),[_c('v-icon',_vm._b({style:(_vm.iconStyle),attrs:{"color":_vm.iconColor},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('click')}}},'v-icon',_vm.$attrs,false),[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }